import React from 'react';
import { LoadingStyles, LoadingTemplateProps } from '../';

export const LoadingDefaultTemplate = (props: LoadingTemplateProps) => {
  return (
    <LoadingStyles className={props.classes}>
      <div
        className="loading-content"
        style={{ width: props.width, height: props.height }}
      ></div>
    </LoadingStyles>
  );
};
